/* eslint-disable no-unmodified-loop-condition */

import Util from '@/assets/libs/util'

let lastMessage = null

const setLastMessage = (message) => {
    lastMessage = Util.deepCopy(message)
}

const clearLastMessage = () => {
    lastMessage = null
}

const getLastMessage = () => {
    return Util.deepCopy(lastMessage)
}

export default {
    setLastMessage,
    getLastMessage,
    clearLastMessage
}



// WEBPACK FOOTER //
// ./src/assets/controllers/TefMessageController.js